import { Spinner, Toaster } from '@ohear/ui'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { Suspense } from 'react'
import { RealtimeToastListener } from './features/notifications/realtime-toast'
import { AuthProvider } from './lib/auth'
import { LocaleProvider } from './lib/i18n/locale-context'
import { OrgProvider } from './lib/org-context'
import { queryClient } from './lib/query-client'
// `routeTree.gen.ts` is generated by `@tanstack/router-plugin/vite` (see vite.config.ts).
// On a fresh checkout it appears after the first `pnpm --filter @ohear/app dev`
// or `vite build` run. CI runs vite build before typecheck so this is always present.
import { routeTree } from './routeTree.gen'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <OrgProvider>
          <AuthProvider>
            {/* Toaster wraps the router so any route can call useToast(); the
                RealtimeToastListener is a sibling that subscribes to org-wide
                realtime topics and pushes role-relevant events into the toast
                queue without rendering anything. */}
            <Toaster>
              <RealtimeToastListener />
              {/* Outer Suspense boundary catches any lazy() chunk that loads
                  before the per-route Suspense kicks in (e.g. during initial
                  hydration of the route tree). */}
              <Suspense
                fallback={
                  <div className="flex justify-center p-12">
                    <Spinner size="lg" label="Loading…" />
                  </div>
                }
              >
                <RouterProvider router={router} />
              </Suspense>
            </Toaster>
          </AuthProvider>
        </OrgProvider>
      </LocaleProvider>
    </QueryClientProvider>
  )
}
